import React, { Component } from 'react';
import axios from 'axios';
import Auth from '../../Modules/Auth';
import { withCookies, Cookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import ReportItemSimple from '../Report/ReportItemSimple';
import ReactGA from 'react-ga';

class ReportList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      report: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.loadList(0);
  }

  loadList = (offset) => {
    const { cookies } = this.props;
    const limit = 6;

    axios.get(
      `${BACKEND_HOST}/reports/?project_id=${cookies.get('project')}&offset=${offset}&limit=${limit}`,
      {
        headers: {
          Authorization: `bearer ${Auth.getToken()}`,
        },
      },
    )
    .then(res => {
      this.setState({ report: res.data.data });
    })
    .catch(err => {
      console.log(err);
    });
  }

  renderList = () => {
    const List = this.state.report.map((item) => {
      return <ReportItemSimple item={item} key={item._id} />;
    });
    return List;
  }

  render() {
    if (this.state.report && this.state.report.length !== 0) {
      return (
        <div className="report_wrap common_wrap">
          <div className="title_wrap">
            <Link to={'/report/'} onClick={() => { ReactGA.event({ category: '대시보드_건축주', label: '작업보고 최신보고서', action: '전체보기' }); }}>
              <div className="more_btn">
                더보기
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
                  <path fill="none" fillRule="evenodd" stroke="#A2A7AE" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.3" d="M1.56.95L6.06 5l-4.5 4.05"/>
                </svg>
              </div>
            </Link>
            <h1>작업보고 <span className="pc_v">최신 보고서</span></h1>
          </div>
          <ul>
            {this.renderList()}
          </ul>
        </div>
      );
    }
    return (<div />);
  }
}

export default withCookies(ReportList);




// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerReportList.js